<template>
  <div class="cxw">
    <div v-if="!ready" class="cxw-note">{{ note }}</div>
    <component
      :is="inner"
      v-else
      v-bind="bound"
      @drill-entity="$emit('drill-entity', $event)"
      @select-patient="$emit('select-patient', $event)"
    />
  </div>
</template>

<script>
import { markRaw } from 'vue';

export default {
  name: 'ComponentWidget',
  props: {
    inputs: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    scope: { type: Object, default: () => ({}) },
    width: { type: Number, default: 0 },
    height: { type: Number, default: 0 },
  },
  emits: ['drill-entity', 'select-patient'],
  data() {
    return { inner: null, loadFailed: false };
  },
  computed: {
    forComponent() {
      const metric = this.scope.metric == null ? null : Number(this.scope.metric);
      const domain = this.scope.domain == null ? null : Number(this.scope.domain);
      return {
        metricIds: metric ? [metric] : [],
        metricId: metric,
        performanceDomainIds: domain ? [domain] : [],
        performanceDomainId: domain,
        isDomain: !(metric && !domain),
        year: Number(this.scope.year) || new Date().getFullYear(),
        entityId: this.scope.entity == null || this.scope.entity === '' ? null : Number(this.scope.entity),
      };
    },
    name() {
      return this.$options.componentName || this.config.component || '';
    },
    needsMetric() {
      return this.$options.needsMetric;
    },
    ready() {
      const have = this.forComponent.metricIds.length > 0 || this.forComponent.performanceDomainIds.length > 0;
      return !!this.inner && (have || !this.needsMetric);
    },
    note() {
      if (this.loadFailed) return `No component ${this.name} is registered.`;
      return this.inner ? 'This widget needs a metric. Set the page\'s metric, or pin one on the widget.' : 'Loading…';
    },
    bound() {
      const declared = this.inner && this.inner.props ? this.inner.props : {};
      const names = Array.isArray(declared) ? declared : Object.keys(declared);
      const merged = { ...this.forComponent, ...(this.config.settings || {}) };
      return Object.fromEntries(Object.entries(merged).filter(([key]) => names.includes(key)));
    },
  },
  async mounted() {
    const { getComponent } = await import('@/config/configurableComponentRegistry');
    const found = this.name ? getComponent(this.name) : null;
    this.loadFailed = !found;
    this.inner = found ? markRaw(found) : null;
  },
};
</script>

<style scoped>
.cxw { width: 100%; height: 100%; overflow: auto; }
.cxw-note { padding: 16px; font-size: 12.5px; color: #8b877f; }
</style>
